import * as THREE from "three";

export function createCamera() {
  // Define camera parameters
  const fov = 50;
  const aspect = window.innerWidth / window.innerHeight;
  const near = 0.1;
  const far = 1000;

  // Create and configure the camera
  const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
  camera.position.set(0, 0, 3);
  return camera;
}
